const MAP_REGION_MANAGEMENT_EXPERIENCE_TYPES = {
  CREATE: '[mapRegionManagementExperience] createMapRegion',
  SET_CREATED: '[mapRegionManagementExperience] setCreated',
  EDIT: '[mapRegionManagementExperience] editMapRegion',
  DELETE: '[mapRegionManagementExperience] deleteMapRegion',
  UPDATE_ATTRIBUTE_ACTIVE: '[mapRegionManagementExperience] updateAttributeActive'
}

export default MAP_REGION_MANAGEMENT_EXPERIENCE_TYPES
